import React from "react";
import { priceFormat } from "../../../helpers";
import { Marker } from "google-maps-react";

const circularMarkerDef = {
    svg: [
        '<svg  viewBox="0 10 50 22" xmlns="http://www.w3.org/2000/svg">',
        '<path d="M 15, 30 a 15,15 0 1,1 30,0 a 15,15 0 1,1 -30,0" fill="{fillColor}"/>',
        "</svg>",
    ].join(""),
    anchor: { x: 12, y: 14 },
    size: { width: 20, height: 20 },
};
  
const coloredMarkerDef = {
    svg: [
        '<svg width="64" height="46" viewBox="0 0 64 46" xmlns="http://www.w3.org/2000/svg">',
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M13 9C11.3431 9 10 10.3431 10 12V26C10 27.6569 11.3431 29 13 29H26.9302L32.0011 34.071L37.0721 29H51C52.6569 29 54 27.6569 54 26V12C54 10.3431 52.6569 9 51 9H13Z" fill="{fillColor}"/>',
        '<path d="M26.9302 29L27.2837 28.6464L27.1373 28.5H26.9302V29ZM32.0011 34.071L31.6476 34.4245L32.0011 34.7781L32.3547 34.4245L32.0011 34.071ZM37.0721 29V28.5H36.865L36.7185 28.6464L37.0721 29ZM10.5 12C10.5 10.6193 11.6193 9.5 13 9.5V8.5C11.067 8.5 9.5 10.067 9.5 12H10.5ZM10.5 26V12H9.5V26H10.5ZM13 28.5C11.6193 28.5 10.5 27.3807 10.5 26H9.5C9.5 27.933 11.067 29.5 13 29.5V28.5ZM26.9302 28.5H13V29.5H26.9302V28.5ZM32.3547 33.7174L27.2837 28.6464L26.5766 29.3536L31.6476 34.4245L32.3547 33.7174ZM36.7185 28.6464L31.6476 33.7174L32.3547 34.4245L37.4256 29.3536L36.7185 28.6464ZM51 28.5H37.0721V29.5H51V28.5ZM53.5 26C53.5 27.3807 52.3807 28.5 51 28.5V29.5C52.933 29.5 54.5 27.933 54.5 26H53.5ZM53.5 12V26H54.5V12H53.5ZM51 9.5C52.3807 9.5 53.5 10.6193 53.5 12H54.5C54.5 10.067 52.933 8.5 51 8.5V9.5ZM13 9.5H51V8.5H13V9.5Z" fill="white" mask="url(#path-1-inside-1)"/>',
        "</svg>",
    ].join(""),
    anchor: { x: 32, y: 32 },
    size: { width: 64, height: 46 },
};
  
const coloredProjectMarkerDef = {
    svg: [
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 39"><defs><style>.cls-1{fill:{fillColor};}.cls-2{fill:#fff;}</style></defs><title>Asset 2</title>',
        '<g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="cls-1" width="36" height="36" rx="4"/>',
        '<path class="cls-2" d="M19.67,16.33a.82.82,0,0,0,.59-.24.85.85,0,0,0,0-1.18.82.82,0,0,0-.59-.24.81.81,0,0,0-.59.24.82.82,0,0,0,0,1.18A.81.81,0,0,0,19.67,16.33ZM23,15.5a.87.87,0,0,0-.24-.59.82.82,0,0,0-.59-.24.81.81,0,0,0-.59.24.82.82,0,0,0,0,1.18.81.81,0,0,0,.59.24.82.82,0,0,0,.59-.24A.87.87,0,0,0,23,15.5Zm-3.33,3.33a.82.82,0,0,0,.59-.24.85.85,0,0,0,0-1.18.82.82,0,0,0-.59-.24.81.81,0,0,0-.59.24.82.82,0,0,0,0,1.18A.81.81,0,0,0,19.67,18.83ZM23,18a.87.87,0,0,0-.24-.59.82.82,0,0,0-.59-.24.81.81,0,0,0-.59.24.82.82,0,0,0,0,1.18.81.81,0,0,0,.59.24.82.82,0,0,0,.59-.24A.87.87,0,0,0,23,18Zm-3.33,3.33a.82.82,0,0,0,.59-.24.85.85,0,0,0,0-1.18.82.82,0,0,0-.59-.24.81.81,0,0,0-.59.24.82.82,0,0,0,0,1.18A.81.81,0,0,0,19.67,21.33ZM23,20.5a.87.87,0,0,0-.24-.59.82.82,0,0,0-.59-.24.81.81,0,0,0-.59.24.82.82,0,0,0,0,1.18.81.81,0,0,0,.59.24.82.82,0,0,0,.59-.24A.87.87,0,0,0,23,20.5ZM12.38,10.92a.63.63,0,0,0-.45.18.67.67,0,0,0-.18.44V24.67h4.58V14a1.88,1.88,0,0,1,1.88-1.87h.21v-.63a.63.63,0,0,0-.19-.44.59.59,0,0,0-.44-.18Zm7.29.62v.63h4a1.84,1.84,0,0,1,1.32.55A1.86,1.86,0,0,1,25.5,14V25.29a.63.63,0,0,1-.62.63h-2.5V23.63a.42.42,0,0,0-.13-.3.4.4,0,0,0-.29-.12H19.88a.41.41,0,0,0-.42.42v2.29H11.13a.64.64,0,0,1-.45-.19.63.63,0,0,1-.18-.44V11.54a1.88,1.88,0,0,1,1.88-1.87h5.41a1.88,1.88,0,0,1,1.88,1.87Zm-5.84,2.29a.81.81,0,0,0,.59-.24.82.82,0,0,0,0-1.18.81.81,0,0,0-.59-.24.82.82,0,0,0-.59.24.85.85,0,0,0,0,1.18A.82.82,0,0,0,13.83,13.83Zm.84,1.67a.83.83,0,0,1-.25.59.81.81,0,0,1-.59.24.82.82,0,0,1-.59-.24.85.85,0,0,1,0-1.18.82.82,0,0,1,.59-.24.81.81,0,0,1,.59.24A.83.83,0,0,1,14.67,15.5Zm-.84,3.33a.81.81,0,0,0,.59-.24.82.82,0,0,0,0-1.18.81.81,0,0,0-.59-.24.82.82,0,0,0-.59.24.85.85,0,0,0,0,1.18A.82.82,0,0,0,13.83,18.83ZM14.67,23a.83.83,0,0,1-.25.59.81.81,0,0,1-.59.24.82.82,0,0,1-.59-.24.85.85,0,0,1,0-1.18.82.82,0,0,1,.59-.24.81.81,0,0,1,.59.24A.83.83,0,0,1,14.67,23Zm-.84-1.67a.81.81,0,0,0,.59-.24.82.82,0,0,0,0-1.18.81.81,0,0,0-.59-.24.82.82,0,0,0-.59.24.85.85,0,0,0,0,1.18A.82.82,0,0,0,13.83,21.33Z"/><polygon class="cls-1" points="18 39 22 35 14 35 18 39"/></g></g></svg>',
    ].join(""),
    anchor: { x: 32, y: 32 },
    size: { width: 64, height: 46 },
};
  
const getCircularMarkerSvg = (color) =>
    `data:image/svg+xml,${encodeURIComponent(
        circularMarkerDef.svg.replace("{fillColor}", color)
    )}`;

const getColoredMarkerSvg = function (color, strokColor, isProject) {
    let svg;
    if (isProject)
        svg = coloredProjectMarkerDef.svg.replace("{fillColor}", color);
    else svg = coloredMarkerDef.svg.replace("{fillColor}", color);

    return svg.replace("{strokColor}", strokColor);
};

const getColoredMarkerUri = function (color, strokColor, isProject) {
    return (
        "data:image/svg+xml," +
        encodeURIComponent(getColoredMarkerSvg(color, strokColor, isProject))
    );
};
  

class MarkersList extends React.Component {
    constructor(props) {
        super(props);
        this.markersRendered = false;
    }

    aggregateItems(array) {
        const counts = {};
        array.forEach(({ latitude, longitude, ...rest }) => {
            const key = JSON.stringify({ latitude, longitude });
            if (!counts[key]) {
                counts[key] = { latitude, longitude, count: 1, items: [{ ...rest }] };
            } else {
                counts[key].count++;
                counts[key].items.push(rest);
            }
        });

        return Object.values(counts);
    };

    shouldComponentUpdate(nextProps, nextState) {
        if (
            JSON.stringify(this.props.places) === JSON.stringify(nextProps.places) &&
            // this.props.zoom === nextProps.zoom &&
            this.markersRendered
        ) {
            return false;
        }
        this.markersRendered = true;

        return true;
    }
  
    render() {
        let Color = window
            .getComputedStyle(document.body, null)
            .getPropertyValue("caret-color");
  
        let StrokColor = window
            .getComputedStyle(document.body, null)
            .getPropertyValue("color");
        let items = this.aggregateItems(this.props.places);

        return (
            <span>
                {items.map((place, i) => {
                    return place.count > 1 ?
                        
                        this.props.zoom <= 11 && !window.location.href.includes('properties') ? (
                            <Marker
                                {...this.props}
                                key={"circle" + i}
                                data={place}
                                position={{ lat: place.latitude, lng: place.longitude }}
                                icon={{
                                    url: getCircularMarkerSvg(place?.items?.filter(i=> +i.isFeatured === 1)?.length>0 ? "rgba(222,164,87,1)" : Color),
                                    anchor: circularMarkerDef.anchor,
                                    size:{ width: 23, height: 23},
                                    scaledSize: circularMarkerDef.size,
                                }}
                                label={{
                                    text: `${place.count}`,
                                    color: "white",
                                    fontSize: "9px",
                                    fontFamily: "Amazon Ember"
                                }}
                            />
                        ) : (
                            <Marker
                                {...this.props}
                                key={"marker" + i}
                                data={place}
                                position={{ lat: place.latitude, lng: place.longitude }}
                                icon={{
                                    url: getColoredMarkerUri(place?.items?.filter(i=> +i.isFeatured === 1)?.length>0 ? "rgba(222,164,87,1)" :Color, StrokColor, false),
                                    labelOrigin: new window.google.maps.Point(32, 20),
                                    anchor: coloredMarkerDef.anchor,
                                    size: coloredMarkerDef.size,
                                    scaledSize: coloredMarkerDef.size,
                                }}
                                label={{
                                    text: `-${place.count}ADs-`,
                                    color: "white",
                                    fontSize: "11px",
                                    fontFamily: "Amazon Ember"
                                }}
                            />
                        ) :
                        this.props.zoom <= 11 && !window.location.href.includes('properties') ? (
                            <Marker
                                {...this.props}
                                key={"circle" + i}
                                data={{ place, ...place.items?.[0] }}
                                position={{ lat: place.latitude, lng: place.longitude }}
                                icon={{
                                    url: getCircularMarkerSvg(+place?.items?.[0]?.isFeatured === 1 ? "rgba(222,164,87,1)" : Color),
                                    anchor: circularMarkerDef.anchor,
                                    size: circularMarkerDef.size,
                                    scaledSize: circularMarkerDef.size,
                                }}
                            />
                        ) : (
                            <Marker
                                {...this.props}
                                key={"marker" + i}
                                data={{ place, ...place.items?.[0] }}
                                position={{ lat: place.latitude, lng: place.longitude }}
                                icon={{
                                    url: getColoredMarkerUri(+place?.items?.[0]?.isFeatured === 1 ? "rgba(222,164,87,1)" : Color, StrokColor, false),
                                    labelOrigin: new window.google.maps.Point(32, 20),
                                    anchor: coloredMarkerDef.anchor,
                                    size: coloredMarkerDef.size,
                                    scaledSize: coloredMarkerDef.size,
                                }}
                                label={{
                                    text: !place?.items?.[0]?.additionalInfo?.filter(i => i.key === '10')?.[0]?.valueText ||
                                        place?.items?.[0]?.additionalInfo?.filter(i => i.key === '10')?.[0]?.valueText === 'لا' ?
                                        place?.items?.[0]?.propertyTypeName?.indexOf(' ') > -1 ? place?.items?.[0]?.propertyTypeName?.substring(0, place?.items?.[0]?.propertyTypeName?.indexOf(' ')) : place?.items?.[0]?.propertyTypeName
                                        : priceFormat(place?.items?.[0]?.defaultPrice),
                                    color: "white",
                                    fontSize: "11px",
                                    fontFamily: "Amazon Ember"
                                }}
                            />
                        );
  
                    // return this.props.project ? (
                    //   <Marker
                    //     {...this.props}
                    //     key={"project" + i}
                    //     data={place}
                    //     position={{ lat: place.latitude, lng: place.longitude }}
                    //     icon={{
                    //       url: getColoredMarkerUri(Color, StrokColor, true),
                    //       labelOrigin: new window.google.maps.Point(32, 20),
                    //       anchor: coloredMarkerDef.anchor,
                    //       size: coloredMarkerDef.size,
                    //       scaledSize: coloredMarkerDef.size,
                    //     }}
                    //   />
                    // ) : (
                    //   <Marker
                    //     {...this.props}
                    //     key={"marker" + i}
                    //     data={place}
                    //     position={{ lat: place.latitude, lng: place.longitude }}
                    //     icon={{
                    //       url: getColoredMarkerUri(Color, StrokColor, false),
                    //       labelOrigin: new window.google.maps.Point(32, 20),
                    //       anchor: coloredMarkerDef.anchor,
                    //       size: coloredMarkerDef.size,
                    //       scaledSize: coloredMarkerDef.size,
                    //     }}
                    //     label={{
                    //       text: priceFormat(place.defaultPrice),
                    //       color: "white",
                    //       fontSize: "12px",
                    //     }}
                    //   />
                    // );
                })}
            </span>
        );
    }
}
  
export default MarkersList;